/**
 * FormEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { FormTypeVersionEntity } from "../FormTypeVersionEntity";
import { VisitEntity } from "../VisitEntity";
import { BugEntity } from "../BugEntity";
import { FormEntity } from "../FormEntity";
declare global {
    interface EntityTypeMap {
        Form: FormEntity;
    }
}
export abstract class FormGeneratedEntity extends BaseEntity {
    public abstract formId: string;
    public abstract templateId: string | null;
    public abstract creator: string | null;
    public abstract creatorId: number | null;
    public abstract indexTypeUser: number | null;
    public abstract filename: string | null;
    public abstract object: string | null;
    public abstract data: string;
    public abstract formTypeVersion: FormTypeVersionEntity;
    public abstract visit: VisitEntity;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
}
